// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/Users/gerverdugo/dev/js/stin-site/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-facturacion-js": () => import("/Users/gerverdugo/dev/js/stin-site/src/pages/facturacion.js" /* webpackChunkName: "component---src-pages-facturacion-js" */),
  "component---src-pages-index-js": () => import("/Users/gerverdugo/dev/js/stin-site/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import("/Users/gerverdugo/dev/js/stin-site/.cache/data.json")

